var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailedIcon = function SvgFailedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    role: "presentation"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#A84835",
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.38 15.915.758 6.886l2.07-3.585 15.62 9.026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.889 18.458-3.586-2.073L12.318.758l3.585 2.07z"
  }))));
};
export default SvgFailedIcon;